import { propertyType } from "@agentcall/core/type"
import { Select } from "@/components/ui/select"

const structureOptions = propertyType.PROPERTY_STRUCTURES.map((item) => ({
  value: item.key,
  label: item.value,
}))

interface PropertyStructureSelectorProps {
  value: string
  onChange: (value: string) => void
  error?: string
  placeholder?: string
  disabled?: boolean
  className?: string
}

export function PropertyStructureSelector({
  value,
  onChange,
  error,
  placeholder = "選択してください",
  disabled = false,
  className,
}: PropertyStructureSelectorProps) {
  return (
    <div className={className}>
      <Select
        value={value}
        onChange={onChange}
        options={structureOptions}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
